import React from 'react';
import { contact2sf } from '../contactEntryUtils';

const normalizeContactObject = (contact) => {
  const { Position__c } = contact;
  if (Position__c && Position__c.includes(';')) {
    contact.Position__c = Position__c.split(';');
  }

  if (Position__c === undefined || Position__c === null) {
    contact.Position__c = [];
  }

  if (!Array.isArray(contact.Position__c)) {
    contact.Position__c = [contact.Position__c];
  }
  return contact;
};
const modes = { read: 'read', edit: 'edit' };

const useContactEntry = (props) => {
  const normalizedContact = normalizeContactObject(props.contact);
  const previousValue = props.contact;
  const [mode, setMode] = React.useState(modes.read);
  const [contact, setContact] = React.useState(normalizedContact);

  const onSave = async () => {
    const x = contact2sf(contact);
    await props.syncContact(x);
    setMode(modes.read);
  };

  const onEdit = () => {
    setMode(modes.edit);
  };

  const onCancel = () => {
    setContact(previousValue);
    setMode(modes.read);
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    if (name === 'Position__c') {
      const { selectedOptions } = event.target;
      let newValue = Array.from(selectedOptions, (option) => option.value);
      setContact({ ...contact, [name]: newValue });

      return;
    }
    setContact({ ...contact, [name]: value });
  };

  const onDelete = () => {
    props.deleteContact(contact);
  };

  return { contact, mode, onSave, onCancel, onEdit, onChange, onDelete };
};

export default useContactEntry;
